var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Com_smart_1"},[_c('title1',{attrs:{"type":"1","title":"场站数量统计"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('div',{staticClass:"back_1"},[_c('div',{staticClass:"before"}),_c('div',{staticClass:"target"},[_c('div',{staticClass:"title"},[_vm._v("已有场站数量(座)")]),_c('div',{staticClass:"number"},[_vm._v("22,272")])])])])
}]

export { render, staticRenderFns }